module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Bold.cfedc367.woff2";